import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const DASABO_LOGO = "/logo.png";

/**
 * LegalLayout — wrapper editoriale per pagine legali (Privacy / Termini / Cookies / GDPR).
 * Mantiene coerenza con la Landing: cream bg, serif accent, sidebar TOC opzionale.
 */
export default function LegalLayout({ title, kicker, updatedAt, children, testid }) {
  return (    <div className="min-h-screen bg-[#FAF9F6] text-[#0A0A0A]" data-testid={testid || "legal-page"}>
      {/* HEADER */}
      <header className="sticky top-0 z-40 backdrop-blur-md bg-[#FAF9F6]/85 border-b border-[#E8E4D9]">
        <div className="max-w-5xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 font-display font-extrabold tracking-tight">
            Autofattura by
            <img src={DASABO_LOGO} alt="Dasabo" className="h-4 w-auto" />
          </Link>
          <Link
            to="/"
            data-testid="legal-back-home"
            className="inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.2em] font-semibold text-[#4A4A4A] hover:text-[#0A0A0A]"
          >
            <ArrowLeft className="w-3 h-3" /> Torna alla home
          </Link>
        </div>
      </header>

      {/* HERO */}
      <section className="max-w-3xl mx-auto px-6 lg:px-8 pt-16 pb-10">
        <div className="text-[10px] uppercase tracking-[0.3em] font-bold text-[#1D4ED8] mb-4 flex items-center gap-2">
          <span className="w-6 h-px bg-[#1D4ED8]" />
          {kicker}
        </div>
        <h1 className="font-display font-extrabold text-4xl md:text-5xl tracking-tighter leading-[0.95]">
          {title}
        </h1>
        {updatedAt && (
          <p className="mt-4 text-sm text-[#737373]">
            Ultimo aggiornamento: <span className="font-semibold text-[#0A0A0A]">{updatedAt}</span>
          </p>
        )}
      </section>

      {/* CONTENT */}
      <article className="max-w-3xl mx-auto px-6 lg:px-8 pb-24 legal-prose">
        {children}
      </article>

      {/* FOOTER */}
      <footer className="border-t border-[#E8E4D9] bg-white/50">
        <div className="max-w-5xl mx-auto px-6 lg:px-8 py-8 text-xs text-[#737373] flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <div>
            © 2026 <span className="font-semibold text-[#0A0A0A]">DASABO SRL</span> · P.IVA/CF 07407380828 ·
            Via Imperatore Federico 100, 90143 Palermo (PA), Italia · PEC: dasabo@pec.it
          </div>
          <div className="flex items-center gap-4">
            <Link to="/privacy" className="hover:text-[#0A0A0A]">Privacy</Link>
            <Link to="/terms" className="hover:text-[#0A0A0A]">Termini</Link>
            <Link to="/cookies" className="hover:text-[#0A0A0A]">Cookie</Link>
            <Link to="/gdpr" className="hover:text-[#0A0A0A]">GDPR</Link>
          </div>
        </div>
      </footer>

      {/* Prose typography for legal text */}
      <style>{`
        .legal-prose h2 {
          font-family: var(--font-display, "Manrope", sans-serif);
          font-size: 1.5rem;
          font-weight: 800;
          letter-spacing: -0.02em;
          margin-top: 2.5rem;
          margin-bottom: 0.75rem;
          color: #0A0A0A;
        }
        .legal-prose h3 {
          font-size: 1.05rem;
          font-weight: 700;
          margin-top: 1.5rem;
          margin-bottom: 0.5rem;
          color: #0A0A0A;
        }
        .legal-prose p, .legal-prose li {
          font-size: 0.95rem;
          line-height: 1.75;
          color: #4A4A4A;
        }
        .legal-prose p { margin-bottom: 1rem; }
        .legal-prose ul { margin-bottom: 1rem; padding-left: 1.25rem; list-style: disc; }
        .legal-prose li { margin-bottom: 0.35rem; }
        .legal-prose strong { color: #0A0A0A; font-weight: 700; }
        .legal-prose .callout {
          background: #F5F2EA;
          border-left: 3px solid #F97316;
          padding: 1rem 1.25rem;
          border-radius: 0.5rem;
          margin: 1.5rem 0;
        }
        .legal-prose .callout p:last-child { margin-bottom: 0; }
      `}</style>
    </div>
  );
}
